import { Separator } from "@/components/ui/separator";

export type ColorToken = {
	name: string;
	variable: string;
	fg?: string;
};

export function ColorSwatch({ token }: { token: ColorToken }) {
	return (
		<div className="flex flex-col gap-1.5">
			<div
				className="h-16 rounded-lg border shadow-sm flex items-end p-2"
				style={{
					backgroundColor: `var(${token.variable})`,
					color: token.fg ? `var(${token.fg})` : "transparent",
				}}
			>
				{token.fg && <span className="text-xs font-medium opacity-80">Aa</span>}
			</div>
			<div>
				<p className="text-sm font-medium">{token.name}</p>
				<p className="text-xs text-muted-foreground font-mono">
					{token.variable}
				</p>
			</div>
		</div>
	);
}

export function Section({
	title,
	children,
}: {
	title: string;
	children: React.ReactNode;
}) {
	return (
		<div className="flex flex-col gap-4">
			<div>
				<h2 className="text-lg font-semibold">{title}</h2>
				<Separator className="mt-2" />
			</div>
			{children}
		</div>
	);
}
